<!--
 * @Description: 运费价格区间配置新增编辑弹出层
 * @Author: Auto
 * @Date: 2026-01-26
 -->
<template>
  <el-dialog :title="isEdit ? '编辑运费价格区间配置' : '新增运费价格区间配置'" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="160px">
      <el-form-item label="区间起始距离（公里）" prop="minDistance">
        <el-input-number
          v-model="form.minDistance"
          :min="0"
          :precision="2"
          :controls="true"
          placeholder="留空表示无下限"
          style="width: 100%">
        </el-input-number>
        <div style="color: #909399; font-size: 12px; margin-top: 5px;">留空表示无下限</div>
      </el-form-item>
      <el-form-item label="是否包含最小距离边界" prop="includeMin">
        <el-radio-group v-model="form.includeMin">
          <el-radio :label="1">包含</el-radio>
          <el-radio :label="0">不包含（左开区间）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="区间结束距离（公里）" prop="maxDistance">
        <el-input-number
          v-model="form.maxDistance"
          :min="0"
          :precision="2"
          :controls="true"
          placeholder="留空表示无上限"
          style="width: 100%">
        </el-input-number>
        <div style="color: #909399; font-size: 12px; margin-top: 5px;">留空表示无上限</div>
      </el-form-item>
      <el-form-item label="是否包含最大距离边界" prop="includeMax">
        <el-radio-group v-model="form.includeMax">
          <el-radio :label="1">包含</el-radio>
          <el-radio :label="0">不包含（右开区间）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="运费单价（元/吨）" prop="unitPrice">
        <el-input-number
          v-model="form.unitPrice"
          :min="0"
          :precision="2"
          placeholder="请输入运费单价"
          style="width: 100%">
        </el-input-number>
      </el-form-item>
      <el-form-item label="排序顺序" prop="sortOrder">
        <el-input-number
          v-model="form.sortOrder"
          :min="0"
          placeholder="用于区间匹配优先级"
          style="width: 100%">
        </el-input-number>
        <div style="color: #909399; font-size: 12px; margin-top: 5px;">用于区间匹配优先级，数字越小优先级越高</div>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: this.show,
      isEdit: false,
      form: {
        minDistance: null,
        maxDistance: null,
        includeMin: 1,
        includeMax: 1,
        unitPrice: null,
        sortOrder: null,
        status: 1
      },
      rules: {
        unitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序顺序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      statusArr: [
        {
          value: 0,
          label: '禁用'
        },
        {
          value: 1,
          label: '启用'
        }
      ]
    }
  },
  watch: {
    show (val) {
      this.visible = val
    },
    visible (val) {
      if (!val) {
        this.$emit('update:show', false)
      }
    },
    info: {
      handler (val) {
        if (val && Object.keys(val).length > 0) {
          this.isEdit = true
          this.form = {
            minDistance: val.minDistance !== null && val.minDistance !== undefined ? val.minDistance : null,
            maxDistance: val.maxDistance !== null && val.maxDistance !== undefined ? val.maxDistance : null,
            includeMin: val.includeMin !== null && val.includeMin !== undefined ? val.includeMin : 1,
            includeMax: val.includeMax !== null && val.includeMax !== undefined ? val.includeMax : 1,
            unitPrice: val.unitPrice,
            sortOrder: val.sortOrder,
            status: val.status !== null && val.status !== undefined ? val.status : 1
          }
          if (val.id) {
            this.form.id = val.id
          }
        } else {
          this.isEdit = false
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetForm () {
      this.form = {
        minDistance: null,
        maxDistance: null,
        includeMin: 1,
        includeMax: 1,
        unitPrice: null,
        sortOrder: null,
        status: 1
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    handleClose () {
      this.visible = false
      this.$emit('update:show', false)
      this.resetForm()
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const formData = { ...this.form }
          // 如果minDistance为空字符串、null或undefined，设置为null
          if (formData.minDistance === '' || formData.minDistance === null || formData.minDistance === undefined || isNaN(formData.minDistance)) {
            formData.minDistance = null
          }
          // 如果maxDistance为空字符串、null或undefined，设置为null
          if (formData.maxDistance === '' || formData.maxDistance === null || formData.maxDistance === undefined || isNaN(formData.maxDistance)) {
            formData.maxDistance = null
          }
          this.$emit('save', formData)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
